import ExprInput from '../../../../builtin/designerComponents/ExprInput';
const __script_base__ = {
  name: 'ReportDimension',
  components: {
    ExprInput
  },
  props: {
    dimension: {
      type: Object,
      default: () => ({
        id: '',
        value: ''
      })
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  created() {
    // 如果没有检测到，自动删掉参数
    if (this.dimension.id) {
      const found = this.options.find(({
        id
      }) => this.dimension.id === id);
      if (!found) {
        this.$emit('delete');
      }
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-reportCard-item"
  }, [_c("div", {
    staticClass: "ucd-reportCard-form-item"
  }, [_c("div", {
    staticClass: "ucd-reportCard-item-label"
  }, [_vm._v("\n      维度ID\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "ucd-reportCard-item-value"
  }, [_c("a-select", {
    staticStyle: {
      width: "calc(100% - 64px)"
    },
    attrs: {
      "allow-clear": ""
    },
    model: {
      value: _vm.dimension.id,
      callback: function ($$v) {
        _vm.$set(_vm.dimension, "id", $$v);
      },
      expression: "dimension.id"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v("\n          " + _vm._s(item.name || item.id) + "(" + _vm._s(item.id) + ")\n        ")]);
  }), 1), _vm._v(" "), _c("button", {
    staticClass: "uc-button ucd-reportCard-btn",
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.$emit("delete");
      }
    }
  }, [_vm._v("\n        删除\n      ")])], 1)]), _vm._v(" "), _c("div", {
    staticClass: "ucd-reportCard-form-item"
  }, [_c("div", {
    staticClass: "ucd-reportCard-item-label"
  }, [_vm._v("\n      维度值\n    ")]), _vm._v(" "), _c("div", {
    staticClass: "ucd-reportCard-item-value"
  }, [_c("ExprInput", {
    staticClass: "ucd-reportCard-item-expr",
    attrs: {
      "multiple-line": true
    },
    model: {
      value: _vm.dimension.value,
      callback: function ($$v) {
        _vm.$set(_vm.dimension, "value", $$v);
      },
      expression: "dimension.value"
    }
  })], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/EventPanel/ReportCardList/ReportDimension.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);